import Util from '../forecast-app/shared/util/util';
import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {ConvertBaselineToPlaceholdersInput} from './__generated__/ConvertBaselineToPlaceholdersMutation.graphql';

const mutation = graphql`
	mutation ConvertBaselineToPlaceholdersMutation($input: ConvertBaselineToPlaceholdersInput!) {
		convertBaselineToPlaceholders(input: $input) {
			project {
				id
				placeholders {
					edges {
						node {
							id
							name
							role {
								id
								name
							}
							placeholderAllocations {
								edges {
									node {
										id
										startDate
										endDate
										monday
										tuesday
										wednesday
										thursday
										friday
										saturday
										sunday
										description
									}
								}
							}
						}
					}
				}
			}
			errors
		}
	}
`;

function commit(
	environment: Environment,
	input: ConvertBaselineToPlaceholdersInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Placeholders', 'Converted Baseline to Placeholders', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
